function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 125"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    textIndent: "0",
    textTransform: "none",
    blockProgression: "tb"
  },
  d: "M50 80a3 3 0 01-3-3V53H23a3 3 0 110-6h24V23a3 3 0 016 0v24h24a3 3 0 010 6H53v24a3 3 0 01-3 3z",
  overflow: "visible",
  color: "#000"
}));